import { useSyncExternalStore } from 'react';

/**
 * Quantas mensagens não lidas (o esqueleto do app é quem acompanha o mensageiro). Fica aqui
 * para os painéis do palco mostrarem o selo sem receber a contagem por propriedade.
 */
let count = 0;
const listeners = new Set<() => void>();

export function setUnreadCount(value: number): void {
  if (value === count) return;
  count = value;
  for (const listener of listeners) listener();
}

export function useUnreadCount(): number {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => count,
    () => 0,
  );
}
